import {NgModule} from '@angular/core';
import {APOLLO_OPTIONS} from 'apollo-angular';
import {ApolloClientOptions, InMemoryCache, DefaultOptions} from '@apollo/client/core';
import {HttpLink} from 'apollo-angular/http';
import { onError } from '@apollo/client/link/error';
import {environment} from '../environments/environment';
import Swal from "sweetalert2";
import { setContext } from '@apollo/client/link/context';

const uri = environment.base_graphql; // <-- add the URL of the GraphQL server here

const authLink = setContext((_, { headers }) => {
  const token = sessionStorage.getItem('token');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

const error = onError(({graphQLErrors, networkError, operation}) => {
  if (graphQLErrors && graphQLErrors.length) {
    if (graphQLErrors[0]?.extensions?.response?.statusCode === 401) {
      window.location.href = '/logout';
      return;
    }
    // Operações que tratam o próprio erro pedem silêncio via context.
    if (operation.getContext().silentError) {
      return;
    }
    // Um alerta por erro: antes o bloco acima e o map abaixo disparavam dois.
    if (graphQLErrors[0].message) {
      Swal.fire({
        title: 'Atenção',
        html: graphQLErrors[0].message,
        icon: 'warning',
        confirmButtonColor: '#032E58',
      });
    }
  }
  if (networkError) {
    const e: any = networkError;
    // Query ausente no servidor chega como erro de rede (HTTP 400), nao em
    // graphQLErrors: a guarda de silencio precisa valer aqui tambem.
    if (operation.getContext().silentError) {
      return;
    }
    if (e.status === 401 || e.statusCode === 401) {
      // `this` e undefined nesta arrow em escopo de modulo: o antigo
      // this.route.navigate lancava TypeError em vez de redirecionar.
      window.location.href = '/login';
      return;
    }
    if (e.status === 400) {
      let str = '';
      e.error.errors.map((x) => {
        if (x.message.length > 0) {
          str += x.message;
        }
      });
      alert(str);
    }
  }
});

export function createApollo(httpLink: HttpLink): ApolloClientOptions<any> {
  const defaultOptions: DefaultOptions = {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'none',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'none',
    },
    mutate: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'none',
    }
  }
  return {
    link: authLink.concat(error.concat(httpLink.create({uri}))), // httpLink.create({uri}),
    cache: new InMemoryCache(),
    defaultOptions: defaultOptions,
  };
}

@NgModule({
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
  ],
})
export class GraphQLModule {}
